import tinycolor from 'tinycolor2';

export const getShadowSize = (index) => {
  const shadowArray = ['shadow-none', 'shadow', 'shadow-md', 'shadow-lg', 'shadow-xl', 'shadow-2xl'];
  return shadowArray[index];
};

export const getContrastingColor = (c) => {
  const color = tinycolor(c);
  const hsl = color.toHsl();
  const originalSaturation = hsl.s;
  if(hsl.l > 0.5) {
    hsl.l = 0.1;
  } else {
    hsl.l = 0.9;
  }
  if(originalSaturation > 0.1) {
    hsl.s = 0.8;
  } else {
    hsl.s = 0;
  }
  return tinycolor(hsl).toHexString();
};

export const darkenColor = (c, amount = 0.1) => {
  if(!c) {
    return '#e5e7eb';
  }
  const color = tinycolor(c).darken(amount * 100);
  // hex drops the alpha, which turns a transparent color into solid black
  return color.getAlpha() < 1 ? color.toRgbString() : color.toHexString();
};
